<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  data() {
    return {
      selectedTag: this.defaultTag,
    };
  },
  methods: {
    click(tag) {
      this.selectedTag = tag;
      this.$emit('input', tag);
    },
  },

  props: {
    value: Object,
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultTag: {
      type: Object,
      default() {
        return {};
      },
    },
  },
});
</script>
<template>
  <div class="bu-is-flex bu-is-flex-wrap-wrap bu-is-align-items-center">
    <div
      v-for="(tag, idx) in tags"
      :key="idx"
      class="cly-vue-color-tag__color-tag-wrapper"
    >
      <div
        v-if="tag.value == selectedTag.value"
        class="cly-vue-color-tag__color-tag cly-vue-color-tag__color-tag__selected bu-is-flex bu-is-align-items-center bu-is-justify-content-center"
        :style="{backgroundColor: tag.label}"
        @click="click(tag)"
      >
        <i class="ion-checkmark cly-vue-color-tag__checkmark" />
      </div>
      <div
        v-else
        class="cly-vue-color-tag__color-tag bu-is-flex bu-is-align-items-center bu-is-justify-content-center"
        :style="{backgroundColor: tag.label}"
        @click="click(tag)"
      />
    </div>
  </div>
</template>
